/* /wishlist page — same RfhqProductGrid + card system every other listing
 * uses (WishlistSource feeds it), rather than webshop's own unthemed
 * Bootstrap markup. Presence-detected mount, same shape as
 * trial_room_page.js - no page controller needs to know this script exists.
 *
 * Every card here also gets an explicit "Remove" link, independent of the
 * heart icon: card/layout/_shared.js suppresses the wishlist heart entirely
 * for any has_variants item (renderTitleRow's `actions.kind !== 'explore'`
 * check), which is most of this catalog - found live, a wishlisted template
 * item had no heart anywhere on its card, so nothing on the page could
 * remove it. That suppression is correct everywhere else (you can't
 * unambiguously wish a specific variant from a bare template card), but on
 * THIS page every card is, by definition, already wished - removing it is
 * never ambiguous the way adding one is, so this button doesn't depend on
 * the heart being present at all.
 */

import { RfhqProductGrid } from './product_card/grid.js';
import { WishlistSource } from './product_card/adapters/wishlist_source.js';
import { cartStore } from './product_card/cart_store.js';

frappe.ready(function () {
	var el = document.getElementById('rfhq-wishlist-grid');
	if (!el) return; // not this page

	var emptyState = document.getElementById('rfhq-wishlist-empty');

	var grid = new RfhqProductGrid({
		el: el,
		source: new WishlistSource({ cartStore: cartStore }),
		// Matches /all-products' own config: raftor_webhq's
		// product_variant_swatches.js resolves a real sellable variant per
		// card (needed for Add to Cart to work at all on a template item -
		// same fix Trial Room needed for its own cart button).
		claimOwnership: false,
		onEmpty: function () {
			el.classList.add('hidden');
			if (emptyState) emptyState.classList.remove('hidden');
		},
	});

	// products-loaded is dispatched globally by grid.js's _afterAppend - only
	// one RfhqProductGrid ever exists on this page, so no extra scoping needed.
	document.addEventListener('products-loaded', addRemoveLinks);

	function addRemoveLinks() {
		el.querySelectorAll('.item-card[data-item-code]').forEach(function (card) {
			if (card.querySelector('.rfhq-wishlist-remove')) return; // already added

			var body = card.querySelector('.card-body, .rfhq-pc-body') || card.querySelector('.card');
			if (!body) return;

			var btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'rfhq-wishlist-remove';
			btn.dataset.itemCode = card.dataset.itemCode;
			btn.textContent = __('Remove from Wishlist');
			body.appendChild(btn);
		});
	}

	document.addEventListener('click', function (e) {
		var btn = e.target.closest('.rfhq-wishlist-remove');
		if (!btn) return;
		e.preventDefault();

		frappe.call({
			method: 'webshop.webshop.doctype.wishlist.wishlist.remove_from_wishlist',
			args: { item_code: btn.dataset.itemCode },
			// reset() clears the grid and calls load() itself - a second
			// load() here would double-fetch and duplicate cards.
			callback: function () {
				grid.reset();
			},
		});
	});

	grid.load();
});
